import { Toolbar as Root } from './Toolbar'
import { Bold, Italic, Underline, InlineCode } from '../MarkButton/MarkButton'
import { OrderedList, BulletList } from '../ListButton/ListButton'
import { MentionButton as Mention } from '../MentionButton/MentionButton'
import { EmojiButton as Emoji } from '../EmojiButton/EmojiButton'

export const Toolbar = {
  Root,
  Bold,
  Italic,
  Underline,
  InlineCode,
  OrderedList,
  BulletList,
  Emoji,
  Mention,
}
